import React from 'react'
import PropTypes from 'prop-types'
import { DetailRow } from '../../PaymentResult/PaymentSuccess'

export default function Wallet(props) {
    const primaryColor = props.primaryColor || '#334155'

    return <DetailRow label="Wallet Name" value={props.data.walletName} primaryColor={primaryColor} />
}

Wallet.propTypes = {
    primaryColor: PropTypes.string,
    data: PropTypes.shape({
        walletName: PropTypes.string.isRequired,
    }).isRequired,
}
